<header
  class="p-header"
  [class.p-header--prequalify]="this.router.url.startsWith('/prequalify')"
  [class.p-header--logged-in]="
    isAuthenticated &&
    !this.router.url.startsWith('/forgot-password') &&
    !this.router.url.startsWith('/signup') &&
    !this.router.url.startsWith('/prequalify') &&
    !this.router.url.startsWith('/login')
  ">
  <h1 class="p-header__company" (click)="openHomePage()">
    <img
      src="assets/img/Tongo_logo_new_2_white.svg"
      class="p-header__logo"
      alt="Tongo Logo" />
  </h1>
  <nav
    class="p-main-nav"
    [ngClass]="{
      'p-main-nav--mobile-hide': !showMenu,
      'p-main-nav--mobile-show': showMenu,
    }">
    @if (
      isAuthenticated &&
      !this.router.url.startsWith('/forgot-password') &&
      !this.router.url.startsWith('/prequalify') &&
      !this.router.url.startsWith('/signup') &&
      !this.router.url.startsWith('/login')
    ) {
      <a
        href="javascript:0"
        class="p-header__nav-item"
        routerLink="/commissions">
        <span class="navbar-item-text">{{
          'navigation.component.commissions_link' | localise: 'Commissions'
        }}</span>
      </a>
      @if (!!user?.productIds?.includes(productEnum.Payment)) {
        <a
          href="javascript:0"
          class="p-header__nav-item"
          routerLink="/payroll-settings">
          <span class="navbar-item-text">{{
            'navigation.component.distributions' | localise: 'Distributions'
          }}</span>
        </a>
      }
      @if (!!user?.productIds?.includes(productEnum.Advance)) {
        <a
          href="javascript:0"
          class="p-header__nav-item"
          routerLink="/activity">
          <span class="navbar-item-text">{{
            'navigation.component.activity_link' | localise: 'Activity'
          }}</span>
        </a>
      }
      @if (!!user?.productIds?.includes(productEnum.Advance)) {
        <a
          href="javascript:0"
          class="p-header__nav-item"
          routerLink="/statements">
          <span class="navbar-item-text">{{
            'navigation.component.statements_link' | localise: 'Statements'
          }}</span>
        </a>
      }
      @if (!!hasTaxDocuments) {
        <a
          href="javascript:0"
          class="p-header__nav-item"
          routerLink="/tax-documents">
          <span class="navbar-item-text">{{
            'navigation.component.tax_documents_link'
              | localise: 'Tax Documents'
          }}</span>
        </a>
      }
    }
    <!--    <a *ngIf="isAuthenticated" (click)="openReferFriend()"-->
    <!--       class="p-button p-button&#45;&#45;rounded p-button&#45;&#45;apply-now-header">Refer a Friend</a>-->
  </nav>
  <!-- hamburger menu icon, mobile only -->
  @if (
    isAuthenticated &&
    !this.router.url.startsWith('/forgot-password') &&
    !this.router.url.startsWith('/prequalify') &&
    !this.router.url.startsWith('/signup') &&
    !this.router.url.startsWith('/login')
  ) {
    <button
      mat-button
      [matMenuTriggerFor]="mainMenu"
      class="p-header__toggle-menu">
      <mat-icon>menu</mat-icon>
    </button>
  }
  <!-- end hamburger -->
  <!-- user menu button -->
  @if (isAuthenticated) {
    <button mat-button [matMenuTriggerFor]="userMenu" class="p-profile-menu">
      {{ user?.firstName }} {{ user?.lastName }}
      <mat-icon>expand_more</mat-icon>
    </button>
  }
  <!-- end user menu button -->

  @if (progressLoadingPageService.isLoading | async) {
    <mat-progress-bar
      mode="indeterminate"
      class="loading-page"></mat-progress-bar>
  }
</header>
<mat-menu #userMenu="matMenu" xPosition="before">
  <button
    mat-menu-item
    routerLink="dashboard"
    [disabled]="
      this.router.url.startsWith('/signup') ||
      this.router.url.startsWith('/prequalify')
    ">
    <mat-icon>dashboard</mat-icon>
    <span>{{
      'navigation.component.dashboard_button' | localise: 'Dashboard'
    }}</span>
  </button>

  <!--  <button-->
  <!--    class="refer-friend"-->
  <!--    mat-menu-item-->
  <!--    [disabled]="this.router.url.startsWith('/signup')"-->
  <!--    (click)="openReferFriend()">-->
  <!--    <mat-icon>mail</mat-icon>-->
  <!--    <span>Refer a Friend</span>-->
  <!--  </button>-->

  <button
    mat-menu-item
    (click)="openProfile()"
    [disabled]="
      this.router.url === '/apply' ||
      this.router.url.startsWith('/signup') ||
      this.router.url.startsWith('/prequalify')
    ">
    <mat-icon>face</mat-icon>
    <span>{{
      'navigation.component.personal_information_button'
        | localise: 'Personal Information'
    }}</span>
  </button>
  @if (!!user?.brokerId || !!partners?.length) {
    <button
      mat-menu-item
      routerLink="/broker"
      [disabled]="
        this.router.url === '/apply' ||
        this.router.url.startsWith('/signup') ||
        this.router.url.startsWith('/prequalify')
      ">
      <mat-icon>business</mat-icon>
      <span class="navbar-item-text">{{
        'navigation.component.business_information_button'
          | localise: 'Business Information'
      }}</span>
    </button>
  }
  <button
    mat-menu-item
    routerLink="agreement"
    [disabled]="
      this.router.url === '/apply' ||
      this.router.url.startsWith('/signup') ||
      this.router.url.startsWith('/prequalify')
    ">
    <mat-icon>grading</mat-icon>
    <span>{{
      'navigation.component.product_terms_and_contract_button'
        | localise: 'Product Terms & Contract'
    }}</span>
  </button>
  <button
    mat-menu-item
    routerLink="/bank-accounts"
    [disabled]="
      this.router.url.startsWith('/signup') ||
      this.router.url.startsWith('/prequalify')
    ">
    <mat-icon fontSet="material-icons-outlined">account_balance</mat-icon>
    <span class="navbar-item-text">{{
      'navigation.component.bank_accounts_button' | localise: 'Bank Accounts'
    }}</span>
  </button>
  <button mat-menu-item (click)="openHelp()">
    <mat-icon>contact_support</mat-icon>
    <span>{{
      'navigation.component.contact_support_button' | localise: 'Help'
    }}</span>
  </button>
  <button mat-menu-item (click)="logout()">
    <mat-icon>logout</mat-icon>
    <span>{{ 'navigation.component.logout_button' | localise: 'Logout' }}</span>
  </button>
</mat-menu>

<mat-menu #mainMenu="matMenu" xPosition="after">
  @if (isAuthenticated) {
    <button mat-menu-item routerLink="/commissions">
      <span class="navbar-item-text">{{
        'navigation.component.commissions_button' | localise: 'Commissions'
      }}</span>
    </button>
    @if (!!user?.productIds?.includes(productEnum.Payment)) {
      <button mat-menu-item routerLink="/activity">
        <span class="navbar-item-text">{{
          'navigation.component.distributions_button'
            | localise: 'Distributions'
        }}</span>
      </button>
    }
    @if (!!user?.productIds?.includes(productEnum.Advance)) {
      <button mat-menu-item routerLink="/payroll-settings">
        <span class="navbar-item-text">{{
          'navigation.component.activity_button' | localise: 'Activity'
        }}</span>
      </button>
    }
    @if (!!user?.productIds?.includes(productEnum.Advance)) {
      <button mat-menu-item routerLink="/statements">
        <span class="navbar-item-text">{{
          'navigation.component.statements_button' | localise: 'Statements'
        }}</span>
      </button>
    }
    @if (!!hasTaxDocuments) {
      <button mat-menu-item routerLink="/tax-documents">
        <span class="navbar-item-text">{{
          'navigation.component.tax_documents_button'
            | localise: 'Tax Documents'
        }}</span>
      </button>
    }
  }
</mat-menu>
